var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysMiniGolf = function SvgSysMiniGolf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 3a.5.5 0 0 1 .5.5V20a.5.5 0 0 1-1 0V3.5A.5.5 0 0 1 8 3Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.954 5.212a.5.5 0 0 1 .658-.258l7 3.062a.5.5 0 0 1 0 .916l-1.098.48a10034.465 10034.465 0 0 0-5.826 2.548l-.053.024a.505.505 0 0 1-.102.037.957.957 0 0 1-.455-.113c-.166-.35.006-.75.049-.783a.842.842 0 0 1 .043-.027l.015-.007.019-.01.02-.009.059-.026.22-.097.789-.346L11.7 9.55l2.414-1.055.05-.021L8.212 5.87a.5.5 0 0 1-.258-.658Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19 18.001a1.001 1.001 0 0 0 0 2 1.001 1.001 0 0 0 0-2Zm0-1a2 2 0 1 1 0 4 2 2 0 0 1 0-4ZM8 17.912c-1.074 0-2.105.149-2.905.42-.66.223-.964.462-1.066.58.102.119.405.357 1.066.58.8.271 1.831.42 2.905.42 1.074 0 2.105-.149 2.905-.42.66-.223.964-.462 1.066-.58-.102-.118-.405-.357-1.066-.58-.8-.271-1.831-.42-2.905-.42Zm0-1c2.76 0 5 .896 5 2s-2.24 2-5 2-5-.896-5-2 2.24-2 5-2Z"
  })));
};
export default SvgSysMiniGolf;